import { CookieService } from 'ngx-cookie-service';

import { CommonModule } from '@angular/common';
import {
  ModuleWithProviders,
  NgModule,
  inject,
  provideAppInitializer,
} from '@angular/core';

import { initAuthenticationService } from './authentication-init';
import { AuthenticationService } from './authentication.service';

@NgModule({
  imports: [CommonModule],
})
export class SharedAuthenticationDataAccessModule {
  static forRoot(): ModuleWithProviders<SharedAuthenticationDataAccessModule> {
    return {
      ngModule: SharedAuthenticationDataAccessModule,
      providers: [
        provideAppInitializer(() => {
          const initializerFn = initAuthenticationService(
            inject(AuthenticationService),
            inject(CookieService),
          );
          return initializerFn();
        }),
      ],
    };
  }
}
